const apiKey = "AIzaSyBbxV1QfJdKkJ4EEYVdPv57Cwd1Vb5CVxQ";

export const googleTranslate = require("google-translate")(apiKey);
